<template>
  <tab-item-template>
    <template #toolbar-items>
      <v-spacer/>
      <v-btn text color="white" :to="{ name: '/edit/list/dataImplementation/DataImplementationList', params: { controllerId: controllerId } }">
        <v-icon class="mr-1">icon-data-implementation</v-icon>
        データ実装管理
      </v-btn>
    </template>

    <el-table
        :data="dataImplementationsView">
      <el-table-column
          min-width="35"
          prop="name"
          label="名称">
      </el-table-column>

      <el-table-column
          min-width="35"
          prop="description"
          label="説明">
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.description"
                placeholder="未設定"
                multi-line>
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          min-width="35"
          prop="status"
          label="ステータス">
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="dataImplementationStatuses[row.status]"
                placeholder="未設定"
                hide-details
                dense>
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>
    </el-table>
  </tab-item-template>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import gql from "graphql-tag";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import BetterSet from "betterset";
import { DATA_IMPLEMENTATION_STATUSES } from "@/constants";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TableInline from "@/components/atoms/TableInline.vue";

export default {
  name: 'DataImplementationTable',
  mixins: [
    PathInfoMixin
  ],
  components: {
    TabItemTemplate,
    TextFieldLike,
    TableInline
  },
  props: {
    dataImplementations: {
      type: Array,
      required: true
    },
    controllerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dataComponentModels: [],
      dataImplementationStatuses: DATA_IMPLEMENTATION_STATUSES
    }
  },
  computed: {
    dataImplementationsView() {
      return this.dataImplementations.map(di => {
        const dcm = this.dataComponentModels.find(dcm => dcm.id === di.dataComponentModelId);
        return {
          ...di,
          name: dcm?.name,
          description: dcm?.description
        };
      });
    }
  },
  methods: {
    ...mapActions({
      gqlQuery: 'hds/gqlQuery',
    }),
    openCreateDialog() {
      this.dialogCreate = [];
    }
  },
  watch: {
    dataImplementations: {
      immediate: true,
      async handler(dataImplementations) {
        // データ実装に使用されているデータ構成モデルを取得
        const dataComponentModelIds = dataImplementations
            .map(di => di.dataComponentModelId)
            .reduce((set, value) => {set.add(value); return set;}, new BetterSet())
            .asArray();
        if(dataComponentModelIds.length === 0) {
          this.dataComponentModels = [];
          return;
        }

        const {dataComponentModels} = await this.gqlQuery({
          query: gql`
            query FindDataComponentModels(
                $dataComponentModelIds: [ID!]!,
            ) {
                dataComponentModels: dataComponentModelInBulk(dataComponentModelIds: $dataComponentModelIds) {
                    id
                    name
                    description
                }
            }`,
          variables: {
            dataComponentModelIds
          },
        });
        this.dataComponentModels = dataComponentModels;
      }
    }
  }
}
</script>
